import { env } from './env'

export const site = {
  name: env.appName,
  shortName: 'NexQR',
  portalName: 'Merchant Portal',
  tagline: 'Secure merchant access',
  location: 'Phnom Penh, Cambodia',
  description: 'Merchant portal for the NexQR platform.',
} as const
